<template>
  <div>
    <div class="alert alert-info">
      The LEARNS Act (<a href="https://arkleg.state.ar.us/Home/FTPDocument?path=%2FACTS%2F2023R%2FPublic%2FACT237.pdf">Act 237 of the 2023 Regular Session</a>) established the Merit Teacher Incentive Fund Program, also known as Merit Pay, to recognize and reward Arkansas's outstanding educators. The program's primary goals are to retain high-performing teachers in classrooms across the state and enhance teacher recruitment and retention in priority (e.g., mentors) and critical shortage areas.
      <br><br>
      An educator deemed eligible under the program shall be rewarded with annual bonuses of no more than ten thousand dollars ($10,000). DESE used administrative data collected through the Statewide Information System, the Educator Effectiveness System, the Arkansas Educator Licensure System, and student state assessment data to identify all eligible educators.
      <br><br>
      <strong>Superintendents will use this module to certify the following:</strong>
      <ul>
        <li>
          Recipients were employed and met the following definition of a teacher during the 2024-25 school year:
          <ul>
            <li>A licensed classroom teacher who spent at least 70% of his or her contracted time working directly with students in a classroom setting teaching all grade-level or subject-matter appropriate classes</li>
            <li>School counselor</li>
            <li>Library media specialist</li>
            <li>Aspiring teacher employed under an Aspiring Teacher Permit</li>
          </ul>
        </li>
        <li>Recipients were not given intensive support status under TESS at any point during the 2024-25 school year.</li>
      </ul>
      Superintendents will use the toggles below to indicate if anyone on the list does not meet the requirements outlined above.<br><br>
      Once the superintendent has completed the list review, they will certify using the toggle.
    </div>
    <h3>Teacher Merit Incentive Overall Summary</h3>
    <div class="row mb-3" v-if="teachers && teachers.length">
      <div class="col-md-12">
        <merit-incentive-category-loadable-pie-chart :teachers="teachers" />
      </div>
      <!-- <div class="col-md-6">
        <merit-incentive-bonus-breakdown-loadable-bar-chart :teachers="teachers" />
      </div> -->
    </div>
    <div class="mb-3" v-if="selectedLea && selectedLea.type == LeaTypes.District">
      <div v-if="certificationStatus">
        <div class="alert alert-success">
          <strong>Certified:</strong> {{ certificationStatus.lastUpdatedBy }} on {{ certificationStatus.lastUpdatedDate | formatDate }}
        </div>
      </div>
    </div>
    <teacher-bonus-table :fiscal-year="fiscalYear" :lea="selectedLea.number" :certification-status="certificationStatus" />
    <div class="alert alert-danger" v-if="isSuperintendent && !certificationStatus">
      <b-form-checkbox
        v-model="certifying"
        switch
        @change="certify()"
        :disabled="certifying">
        <span v-if="certifying"><i class="fa fa-spinner fa-spin" /> Certifying...</span>
        <strong v-else>
          As district superintendent, I have reviewed the list of recipients above and indicated if each recipient met the definition of teacher and held the appropriate status under TESS.
        </strong>
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import TeacherBonusTable from './tables/TeacherBonusTable.vue'
import MeritIncentiveCategoryLoadablePieChart from './charts/MeritIncentiveCategoryLoadablePieChart.vue'
// import MeritIncentiveBonusBreakdownLoadableBarChart from './charts/MeritIncentiveBonusBreakdownLoadableBarChart.vue'
import { mapState } from 'vuex'
import { LeaTypes } from '@/helpers/leaTypes'

export default {
  components: {
    TeacherBonusTable,
    MeritIncentiveCategoryLoadablePieChart,
    // MeritIncentiveBonusBreakdownLoadableBarChart
  },
  data() {
    return {
      LeaTypes,
      certifying: false,
      certificationStatus: null
    }
  },
  computed: {
    ...mapState('tgsModule', ['fiscalYear', 'teacherMeritPays']),
    selectedLea() {
      return this.$store.state.globalModule.leaContext.SelectedLea
    },
    teachers() {
      return this.teacherMeritPays || []
    },
    isSuperintendent() {
      return this.$store.state.globalModule.userContext.isSuperintendent;
    }
  },
  watch: {
    selectedLea: {
      immediate: true,
      handler() {
        if (this.selectedLea && this.selectedLea.type == LeaTypes.District && this.fiscalYear) {
          this.fetchCertificationStatus();
        }
      }
    },
    fiscalYear: {
      immediate: true,
      handler() {
        if (this.selectedLea && this.selectedLea.type == LeaTypes.District && this.fiscalYear) {
          this.fetchCertificationStatus();
        }
      }
    }
  },
  methods: {
    async fetchCertificationStatus() {
      try {
        const res = await fetch(`/api/merit-incentive/${this.fiscalYear}/${this.selectedLea.number}/certify`);
        if (res.ok) {
          this.certificationStatus = await res.json();
        } else if (res.status === 404) {
          this.certificationStatus = null;
        } else {
          this.certificationStatus = null;
          this.$bvToast && this.$bvToast.toast('Failed to fetch certification status.', { variant: 'warning', title: 'Warning' });
        }
      } catch (e) {
        this.certificationStatus = null;
        this.$bvToast && this.$bvToast.toast('Failed to fetch certification status.', { variant: 'warning', title: 'Warning' });
      }
    },
    async certify() {
      this.certifying = true;
      try {
        const res = await fetch(`/api/merit-incentive/${this.fiscalYear}/${this.selectedLea.number}/certify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        if (res.ok) {
          this.certificationStatus = await res.json();
          this.$bvToast && this.$bvToast.toast('Certification successful.', { variant: 'success', title: 'Certified' });
        } else {
          this.$bvToast && this.$bvToast.toast('Certification failed.', { variant: 'danger', title: 'Error' });
        }
      } catch (e) {
        this.$bvToast && this.$bvToast.toast('Certification failed.', { variant: 'danger', title: 'Error' });
      } finally {
        this.certifying = false;
      }
    }
  },
  filters: {
    formatDate(val) {
      if (!val) return '';
      return new Date(val).toLocaleString();
    }
  }
}
</script>

<style scoped>
</style>
